module.exports = __webpack_public_path__ + "static/img/ibm-plex-mono-v12-latin-300italic.1706ba2.svg";